// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"48bf148c","453":"f0933132","667":"6570b822","821":"e7d049f7","977":"79e08ce3"}[chunkId] + ".chunk.js");